// extracted by mini-css-extract-plugin
export default {"accordionContainer":"SettingsPage_accordionContainer__7Dt2T"};